import React, { Component } from 'react';
import { FacebookProvider, Comments } from 'react-facebook';
import Config from '~/config';

class FacebookComment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      href: '',
    };
  }

  componentDidMount() {
    const { href } = window.location;
    this.setState({ href });
  }

  render() {
    const { href } = this.state;

    return (
      <div className="image-facebook-comment">
        <FacebookProvider appId={Config.facebookAppID}>
          <Comments href={href} width="100%" />
        </FacebookProvider>
        <style jsx global>
          {`
            .image-facebook-comment iframe {
              width: 100% !important;
            }
          `}
        </style>
      </div>
    );
  }
}

export default FacebookComment;
